export interface ErrorResponseModel {
    code: number;
    message: string;
}
